import React from "react";
import { Row, Col, Button, Image, Container } from "react-bootstrap";
import Rating from "@mui/material/Rating";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import axios from "axios";
import { base_url, ImageUrl, postHeader } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Heading from "../ui/Heading";
import { isDesktop, isMobile } from "react-device-detect";
import lineBlack from "../../../themes/dubai/assets/images/icons/line-black.png";
import google from "../../../themes/dubai/assets/images/google-reviews.jpg";
import yelp from "../../../themes/dubai/assets/images/yelp-reviews.jpg";


const Customer = () => {
  const [customerData, setCustomerData] = React.useState([]);
  React.useEffect(() => {
    GetCustomerRewies();
    console.log("customerdta", customerData);
  }, []);
  const GetCustomerRewies = () => {
    axios
      .get(`${base_url}/common/site_reviews`, {
        headers: postHeader,
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          setCustomerData(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let settings1 = {
    dots: false,
    infinite: true,
    speed: 500,
    accessibility: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow: <Image src={`${ImageUrl}theme/showcase/left.png`} alt="arrow" />,
    nextArrow: <Image src={`${ImageUrl}theme/showcase/right.png`} alt="arrow" />,
    responsive: [
      {
        breakpoint: 1479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  let settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    accessibility: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow: <Image src={`${ImageUrl}theme/showcase/left.png`} alt="arrow" />,
    nextArrow: <Image src={`${ImageUrl}theme/showcase/right.png`} alt="arrow" />,
    responsive: [
      {
        breakpoint: 1479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <section className="rcs_customer_say_section">
      <Container>
        <div className="d-flex align-items-center justify-content-center pb-3">
        <Heading>
          <h2>What People Say</h2>
          <Image src={lineBlack} alt="Black Image Line" className="img-fluid"/>
        </Heading>

          {/* {isDesktop && (
            <div className="rcs_customer_review_btn">
              <Button
                className="btn outline-base-btn large"
                onClick={() =>
                  window.open(customerData?.google_review_url, "_blank")
                }
              >
                {" "}
                Write a Review{" "}
              </Button>
            </div>
          )} */}
        </div>

        <Row>
          {/* <Col lg={12} data-aos="fade-up" data-aos-duration="1400">
            <div className="rcs_customer_review_slider">
              <Slider className="rcs_customer_say_inner" {...settings2}>
                {customerData?.data?.map((customdata) => (
                  <div className="rcs_customer_review_slide_item">
                    <div className="rcs_customer_slide_title_img mb-4">
                      <div className="rcs_customer_review_slide_img">
                        <LazyLoadImage
                          src={`${ImageUrl}theme/showcase/review.png`}
                          alt="Google Review Image"
                          onClick={() =>
                            window.open(
                              "https://www.google.com/search?client=firefox-b-d&q=belgium+webnet#lrd=0x89c2590a50b3a235:0x8af09874060f51fc,1,,,,",
                              "_blank"
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="rcs_customer_slide_text_content mb-4">
                      <p>
                        {customdata?.review?.slice(0, 150)}
                        {customdata?.review?.length > 150 ? "..." : ""}
                      </p>
                      <Link
                        to="#"
                        onClick={() =>
                          window.open(
                            "https://www.google.com/search?client=firefox-b-d&q=belgium+webnet#lrd=0x89c2590a50b3a235:0x8af09874060f51fc,1,,,,",
                            "_blank"
                          )
                        }
                      >
                        {" "}
                        Read More{" "}
                      </Link>
                    </div>
                    <div className="rcs_customer_review_footer d-flex align-items-center">
                      <div className="name-charAt mr-3">
                        {customdata?.username.charAt(0)}
                      </div>
                      <div className="rcs_customer_review_slide_title">
                        <h3>{customdata?.username}</h3>
                        <Rating
                          name="half-rating-read"
                          defaultValue={5}
                          precision={customdata?.rating}
                          size="medium"
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Col> */}
          <Col sm={12} md={6}>
          <div className="du_customer_slider_outer">
          <div className="title-box2 text-center address_heading">
                                <div className="goog_reviews">
                                    <a href="javascript:void(0)" target="_blank" rel="noreferrer"><img src={google} alt="goog-reviews"/></a>
                                </div>
                            </div>
  <div className="testimo-slider2">
                                <div className="testimonial-icon1 ">
                                    <i className="fa fa-quote-left"></i>
                                </div>
                                <Slider className="rcs_customer_say_inner" {...settings2}>
                                <div>
                                    <div className="item">
                                        <p className="desc ">I've been a customer of Precious Diamonds for many years and I've been very happy with them. They have a wide selection of high quality items and if I ever need anything, they are more than willing to <a href="javascript:void(0)" target="_blank" className="review_read_more">Read more...</a></p>
                                        <div className="reviews_icon">
                                        <Rating
                          name="half-rating-read"
                          defaultValue={5}
                          precision={5}
                          size="medium"
                          readOnly
                        />
                                        </div>
                                        <h3 className="title18"><a href="javascript:void(0)" className="txt-black">Karen U.</a></h3>
                                    </div>
                            
                        </div>
                        <div>
                                    <div className="item">
                                        <p className="desc ">I've been a customer of Precious Diamonds for many years and I've been very happy with them. They have a wide selection of high quality items and if I ever need anything, they are more than willing to <a href="javascript:void(0)" target="_blank" className="review_read_more">Read more...</a></p>
                                        <div className="reviews_icon">
                                        <Rating
                          name="half-rating-read"
                          defaultValue={5}
                          precision={5}
                          size="medium"
                          readOnly
                        />
                                        </div>
                                        <h3 className="title18"><a href="javascript:void(0)" className="txt-black">Karen U.</a></h3>
                                    </div>
                            
                        </div>
                        <div>
                                    <div className="item">
                                        <p className="desc ">I've been a customer of Precious Diamonds for many years and I've been very happy with them. They have a wide selection of high quality items and if I ever need anything, they are more than willing to <a href="javascript:void(0)" target="_blank" className="review_read_more">Read more...</a></p>
                                        <div className="reviews_icon">
                                        <Rating
                          name="half-rating-read"
                          defaultValue={5}
                          precision={5}
                          size="medium"
                          readOnly
                        />
                                        </div>
                                        <h3 className="title18"><a href="javascript:void(0)" className="txt-black">Karen U.</a></h3>
                                    </div>
                            
                        </div>
                        {/* </div> */}
                          
                        </Slider>
                              
          </div>       </div>
                        </Col>
                        <Col sm={12} md={6}>
          <div className="du_customer_slider_outer">
          <div className="title-box2 text-center address_heading">
                                <div className="goog_reviews">
                                    <a href="javascript:void(0)" target="_blank"><img src={yelp} alt="goog-reviews"/></a>
                                </div>
                            </div>
  <div className="testimo-slider2">
                                <div className="testimonial-icon1 red_color">
                                    <i className="fa fa-quote-left"></i>
                                </div>
                                <Slider className="rcs_customer_say_inner" {...settings1}>
                                <div>
                                    <div className="item">
                                        <p className="desc ">I've been a customer of Precious Diamonds for many years and I've been very happy with them. They have a wide selection of high quality items and if I ever need anything, they are more than willing to <a href="javascript:void(0)" target="_blank" className="review_read_more">Read more...</a></p>
                                        <div className="reviews_icon">
                                        <Rating
                          name="half-rating-read"
                          defaultValue={5}
                          precision={5}
                          size="medium"
                          readOnly
                        />
                                        </div>
                                        <h3 className="title18"><a href="javascript:void(0)" className="txt-black">Karen U.</a></h3>
                                    </div>
                            
                        </div>
                        <div>
                                    <div className="item">
                                        <p className="desc ">I've been a customer of Precious Diamonds for many years and I've been very happy with them. They have a wide selection of high quality items and if I ever need anything, they are more than willing to <a href="javascript:void(0)" target="_blank" className="review_read_more">Read more...</a></p>
                                        <div className="reviews_icon">
                                        <Rating
                          name="half-rating-read"
                          defaultValue={5}
                          precision={5}
                          size="medium"
                          readOnly
                        />
                                        </div>
                                        <h3 className="title18"><a href="javascript:void(0)" className="txt-black">Karen U.</a></h3>
                                    </div>
                            
                        </div>
                        <div>
                                    <div className="item">
                                        <p className="desc ">I've been a customer of Precious Diamonds for many years and I've been very happy with them. They have a wide selection of high quality items and if I ever need anything, they are more than willing to <a href="javascript:void(0)" target="_blank" className="review_read_more">Read more...</a></p>
                                        <div className="reviews_icon">
                                        <Rating
                          name="half-rating-read"
                          defaultValue={5}
                          precision={5}
                          size="medium"
                          readOnly
                        />
                                        </div>
                                        <h3 className="title18"><a href="javascript:void(0)" className="txt-black">Karen U.</a></h3>
                                    </div>
                            
                        </div>
                        {/* </div> */}
                          
                        </Slider>
                              
          </div>       </div>
                        </Col>
        </Row>

        {/* {isMobile && (
          <div className="rcs_customer_review_btn text-center mt-5">
            <Button
              className="btn outline-base-btn large"
              onClick={() =>
                window.open(customerData?.google_review_url, "_blank")
              }
            >
              {" "}
              Write a Review{" "}
            </Button>
          </div>
        )} */}
      </Container>
    </section>
  );
};

export default Customer;
